export interface GDVCost {
    id: number;
    appraisal_basic_id: number;
    title: string;
    area_aqm: number;
    area_sqft: number;
    price_per_sqm: number;
    price_per_sqft: number;
    total_price: number;
    no_of_bedroom: number;
    no_of_bath: number;
    no_of_showrroom: number;
    garden: 'Yes' | 'No';
    balcony: 'Yes' | 'No';
    location: string;
}

// to single object maping
export const mapGDVCost = (data:any): GDVCost => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: GDVCost ={
        id: data.id,
        appraisal_basic_id: data.appraisal_basic_id,
        title: data.title,
        area_aqm: data.area_aqm,
        area_sqft: data.area_sqft,
        price_per_sqm: data.price_per_sqm,
        price_per_sqft: data.price_per_sqft,
        total_price: data.total_price,
        no_of_bedroom: data.no_of_bedroom,
        no_of_bath: data.no_of_bath,
        no_of_showrroom: data.no_of_showrroom,
        garden: data.garden,
        balcony: data.balcony,
        location: data.location,
    }
    return res;
}

// maping list objects
export const mapGDVCosts = (data:any[]): GDVCost[] => {
     if (!Array.isArray(data)) {
       throw new Error('Invalid Data');
     }
     return data.map(mapGDVCost);
}